/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';

export namespace AgentCardDetailsWrapper {
  export interface Props extends React.HTMLAttributes<HTMLDivElement> {}
}

const styles = StyleSheet.create({
  agentCardDetailsWrapper: {
    marginTop: 16,
    marginBottom: 16,
  },
});

export const AgentCardDetailsWrapper: React.FC<AgentCardDetailsWrapper.Props> = ({ children, ...htmlProps }) => {
  return (
    <div className={css(styles.agentCardDetailsWrapper)} {...htmlProps}>
      {children}
    </div>
  );
};
